function notEmpty(input) {
  return !!input
}

exports.customValid = function customValid(input, validator, toastMessage) {
  validator = validator || notEmpty
  if (!validator(input)) {
    this.showToast({
      content: toastMessage,
    })
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./client/utils/validator.js